module.exports = __webpack_public_path__ + "img/avatar5.4eb0a626.png";